import { render, staticRenderFns } from "./DiscordIcon.vue?vue&type=template&id=46a429a7&scoped=true"
import script from "./DiscordIcon.vue?vue&type=script&lang=js"
export * from "./DiscordIcon.vue?vue&type=script&lang=js"
import style0 from "./DiscordIcon.vue?vue&type=style&index=0&id=46a429a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a429a7",
  null
  
)

export default component.exports